export const ADD_ALL_USERS = "ADD_ALL_USERS";
export const REMOVE_ALL_USERS = "REMOVE_ALL_USERS";
export const EDIT_USER_BY_INDEX = "EDIT_USER_BY_INDEX";
export const REMOVE_USER_BY_INDEX = "REMOVE_USER_BY_INDEX";
